import React from 'react'
export const Help = () => {
    return (
        <div>
            <p>Whoops! I am in Help screen.</p>
        </div>
    )
}